import React, { useState, useEffect } from 'react';
import Button from "../button/button_v2.js";
import * as S from './withCupomStyles.js';
import logo from "../../assets/logo-verde-fundo-branco.png"
import check from "../../assets/check-verde.png"
import x from "../../assets/X-cinza.png"
import { withRouter } from "react-router-dom"
import api from '../../services/api.js';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min.js';
import Carousel from '../carousel/index.js';
import { DescriptionFunctions } from './descriptionFunctions.js';
import { Auxiliar, BodyM } from '../../styles/stylesTypography.js';
import { theme } from '../../styles/theme.js';
import maintainUtm, { generateButtonId } from '../../services/maintainUtm';
import {getCurrentPageIdWithDevice} from "../../services/maintainUtm/idPages";



function PlanTableWithCupom({ ...props }) {

    const [isMobile, setIsMobile] = useState(false);
    const [positionMiddle, setPositionMiddle] = useState(false);
    const [planos, setPlanos] = useState([]);
    const [headers, setHeaders] = useState([]);
    const [permissoes, setPermissoes] = useState([]);
    const [grid, setGrid] = useState([]);
    const [gridAnual, setGridAnual] = useState([]);
    const [showPrepaid, setShowPrepaid] = useState(false);

    const location = useLocation();

    useEffect(() => {
        // Ler o parâmetro 'prepaid' da URL
        const searchParams = new URLSearchParams(location.search);
        const isPrepaid = searchParams.get('prepaid') === 'true';

        // Ativar o pré-pago se o parâmetro for true
        if (isPrepaid) {
            setShowPrepaid(true);
        }
    }, [location.search]);

    const getUtmUrl = (planoId) => {
        try {
            const currentUrl = new URL(window.location.href);
            const utmParams = new URLSearchParams(currentUrl.search);

            // Verifica se já tem UTM
            const hasUtm = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'cupom'].some(param => utmParams.has(param));

            // Se não tiver UTM, adiciona a UTM padrão
            if (!hasUtm) {
                utmParams.set('utm_term', 'NONE');
                utmParams.set('utm_source', 'sistema');
                utmParams.set('utm_medium', 'box-planos');
                utmParams.set('utm_campaign', 'black-november-25');
                utmParams.set('cupom', 'AGROBLACK');
            }

            // Verifica se já tem o cupom, se não, adiciona
            if (!utmParams.has('cupom') && (planoId === 7 || planoId === 4 || planoId === 5)) {
                utmParams.set('cupom', 'AGROBLACK');
            }

            if (hasUtm && planoId !== 6) {
                return `/compra?${planoId}&${utmParams.toString()}`;
                
            } else if ( planoId === 7 || planoId === 4 || planoId === 5) {
                return `/compra?${planoId}&cupom=AGROBLACK`;
            } else if (planoId === 6) {
                return `/compra?${planoId}`;
            }
        } catch (error) {
            // Fallback para URL padrão em caso de erro
            if (planoId === 7 || planoId === 4 || planoId === 5 ) {
                return `/compra?${planoId}&cupom=AGROBLACK`;
            } else if (planoId === 6) {
                return `/compra?${planoId}`;
            }
        }
    };

    const isPlanoEmPromocao = (planoId) => {
        return !!props.campaign?.agro_campaign_plans?.some(p => p.agro_plan_id === planoId);
    };

    const assinar = (planoId) => {
        const currentPageId = getCurrentPageIdWithDevice();
        const hasUser = localStorage.getItem('@userinfo');
        const planTrackingId = planoId === 7 ? "planobasic" : planoId === 4 ? "planolight" : planoId === 5 ? "planopro" : "planopre";
        const campaignTitle = props.campaign?.nome_campanha;
        const buttonId = campaignTitle
            ? generateButtonId(campaignTitle, `${currentPageId}`, `${currentPageId}-boxplanoscupom`)
            : `${currentPageId}-boxplanoscupom`;
        let search = width > 768
            ? maintainUtm(`${currentPageId}-${planTrackingId}`, true)
            : maintainUtm(buttonId, true);

        const campaignPlan = props.campaign?.agro_campaign_plans?.find(p => p.agro_plan_id === planoId);
        const cupom = campaignPlan ? props.campaign?.agro_coupon?.nome_cupom : null;

        // O cupom só pode ir para o checkout quando o plano clicado está
        // de fato contemplado pela campanha (presente em agro_campaign_plans).
        // Caso contrário, remove qualquer cupom vindo da URL atual (ex.: UTM
        // de campanha), já que a rota não retornou desconto para esse plano.
        const searchParams = new URLSearchParams(search.replace(/^[?&]/, ''));
        if (cupom) {
            searchParams.set('cupom', cupom);
        } else {
            searchParams.delete('cupom');
        }
        const newSearchString = searchParams.toString();
        search = newSearchString ? `&${newSearchString}` : '';

        if (!hasUser) {
            localStorage.setItem('next_route_plans', `/compra?${planoId}${search}`);
            props.history.push({ pathname: '/login', search });
            return;
        }

        localStorage.setItem('@loginReload', 'true');
        localStorage.setItem('@CupomReloaded', 'false');
        // Garante que /compra force um reload ao chegar (mesmo mecanismo usado
        // em planTable/index.js), pois a navegação via SPA (history.push) não
        // é suficiente para os elementos da tela (plano, cupom, preços) se
        // ajustarem corretamente - sem isso é preciso um F5 manual.
        localStorage.setItem('@PlanReloaded', 'true');
        props.history.push(`/compra?${planoId}${search}`);
    };

    const getPlanos = async () => {
        try {
            const response = await api.get(`/planos/funcoes`);
            const data = response.data.data;
            setPlanos(data.planos);
            setHeaders(data.funcoes);
            setPermissoes(data.permissoes);
            setGrid(data.grid);
            setGridAnual(data.grid_anual);
        } catch (error) {
            console.error("Erro ao buscar dados da API:", error);
        }
    };

    useEffect(() => {
        getPlanos();
    }, []);

    const [width, setWidth] = useState(window.innerWidth);

    useEffect(() => {
        const handleResize = () => {
            setWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [width]);

            const SubscribeBasic = () => {
                if (props.location.pathname === '/receituario-agronomico-2026b') {
                    return null;
                } else if (props.location.pathname === '/receituario-agronomico-2026') {
                    return (
                        <a href='#teste-gratis'><Button value='garantir desconto' margin='15px' height='36px' width='186px' /></a>
                    )
                } else {
                    return (
                        <Button  value={isPlanoEmPromocao(7) ? 'garantir desconto' : 'assinar'} margin='15px 0' height='36px' width={isPlanoEmPromocao(7) ? 'auto' : '110px'} onClick={() => assinar(7)} />
                    )
                }
            }

            const subscribeLight = () => {
                if (props.location.pathname === '/receituario-agronomico-2026b') {
                    return null;
                } else if (props.location.pathname === '/receituario-agronomico-2026') {
                    return (
                        <a href='#teste-gratis'><Button value='garantir desconto' margin='15px' height='36px' width='186px' /></a>
                    )
                } else {
                    return (
                        <Button value={isPlanoEmPromocao(4) ? 'garantir desconto' : 'assinar'} margin='15px 0' height='36px' width={isPlanoEmPromocao(4) ? 'auto' : '110px'} onClick={() => assinar(4)} />
                    )
                }
            }

            const subscribePro = () => {
                if (props.location.pathname === '/receituario-agronomico-2026b') {
                    return null;
                } else if (props.location.pathname === '/receituario-agronomico-2026') {
                    return (
                        <a href='#teste-gratis'><Button value='garantir desconto' margin='15px' height='36px' width='186px' /></a>
                    )
                } else {
                    return (
                        <Button value={isPlanoEmPromocao(5) ? 'garantir desconto' : 'assinar'} margin='15px 0' height='36px' width={isPlanoEmPromocao(5) ? 'auto' : '110px'} onClick={() => assinar(5)} />
                    )
                }
            }

            const SubscribeMobile = () => {
                if (props.location.pathname === '/receituario-agronomico-2026b') {
                    return null;
                } else if (props.location.pathname === '/receituario-agronomico-2026') {
                    return (
                        <a href='#teste-gratis'><Button value='garantir desconto' margin='15px' height='36px' width='186px' /></a>
                    )
                } else {
                    return (
                        <Button value={isPlanoEmPromocao(5) ? 'garantir desconto' : 'assinar'} margin='15px 0' height='36px' width={isPlanoEmPromocao(5) ? 'auto' : '110px'} onClick={() => assinar(5)} />
                    )
                }
            }

            const currentPageId = getCurrentPageIdWithDevice();
           const searchCadastro = maintainUtm(`${currentPageId}-boxplanoscupom`);

            const PriceContainerDesktop = () => {
                if (props.showPlanTablePrices === false && width > 1237) {
                    if (props.location.pathname === '/receituario-agronomico-2026' || props.location.pathname === '/receituario-agronomico-2026b') {
                        return (
                            <div style={{ width: '100%', display: 'flex', justifyContent: 'center', padding: '40px 0' }}>
                                <Button value='TESTE GRÁTIS AGORA' margin='25px 0' height='54px' width='200px' onClick={() => window.location.href=`/cadastro${searchCadastro}`} />
                            </div>
                        );
                    }
                    return null;
                }
                if (props.location.pathname === '/receituario-agronomico-2026') { 
                    return (
                        <div style={{display: "flex", flexDirection: "column"}}>
                            <S.PriceRow isPrepaid={false} isRA2025={true}>
                                <S.TableCell>
                                    <S.AdditionalText>
                                        *Válido para os primeiros 12 meses<br/>Para mais usuários ou receitas, <a onClick={() => window.location = '/simulacaoplano/7?'}>simule aqui.</a> <br/>Quanto mais você contratar, maior é o seu desconto!
                                    </S.AdditionalText>

                                    {/* <S.AdditionalText>
                                        *Para mais usuários ou receitas, <a href='/simulacaoplano/7'>simule aqui</a>. <br/>Quanto mais você contratar, maior é o seu desconto!
                                    </S.AdditionalText> */}
                                </S.TableCell>
                                {gridAnual
                                    .filter(g => g.plan_id !== 6)
                                    .map((g, index) => {
                                        const campaignPlan = props.campaign?.agro_campaign_plans?.find(p => p.agro_plan_id === g.plan_id);
                                        const gridMensal = grid.find(m => m.plan_id === g.plan_id);
                                        const oldVlr = campaignPlan ? g.vlr : (gridMensal ? gridMensal.vlr : g.vlr);
                                        const oldCents = campaignPlan ? g.cents : (gridMensal ? gridMensal.cents : g.cents);
                                        return (
                                        <S.TableCell key={index}>
                                            <S.PriceWithButtonContainer>
                                                <S.OldPrice>
                                                    <span className="currency-symbol">R$</span>
                                                    <span>{oldVlr}</span>
                                                    <span className="cents">,{oldCents}</span>
                                                </S.OldPrice>

                                                {campaignPlan ? (
                                                    (() => {
                                                        const valueNum = Number(String(campaignPlan.valor_desconto ?? ''));
                                                        const brl = valueNum.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
                                                        const [finalInt, finalCents] = brl.split(',');
                                                        return (
                                                            <S.Price promo={true}>
                                                                <span className="currency-symbol">R$</span>
                                                                <span>{finalInt}</span>
                                                                <span className="cents">,{finalCents}*</span>
                                                            </S.Price>
                                                        );
                                                    })()
                                                ) : (
                                                    <S.Price>
                                                        <span className="currency-symbol">R$</span>
                                                        <span>{g.vlr}</span>
                                                        <span className="cents">,{g.cents}</span>
                                                    </S.Price>
                                                )}

                                                <S.PriceDescription>mensais por usuário</S.PriceDescription>
                                                <S.PriceDescriptionForAnual>NO PLANO ANUAL</S.PriceDescriptionForAnual>

                                                {g.plan_id === 7 ? (
                                                    SubscribeBasic()
                                                ) : g.plan_id === 4 ? (
                                                    subscribeLight()
                                                ) : g.plan_id === 5 ? (
                                                    subscribePro()
                                                ) : null}
                                            </S.PriceWithButtonContainer>
                                        </S.TableCell>
                                        );
                                    })}
                            </S.PriceRow>

                            {width > 1237 ? (
                                <S.PrePaidPlanContainer isPrepaid={true}>
                                    Conheça o <button onClick={() => setShowPrepaid(true)}><a href='/planos'>Plano Pré-Pago</a></button> e compre créditos para utilizar quando quiser.
                                </S.PrePaidPlanContainer>
                            ): ""}
                            
                        </div>
                            
                        )
                        
            }else {
                return (
                <S.PriceRow isPrepaid={false}>
                <S.TableCell>
                    <S.AdditionalText>
                        *Válido para os primeiros 12 meses<br/>Para mais usuários ou receitas, <a onClick={() => window.location = '/simulacaoplano/7?'}>simule aqui.</a> <br/>Quanto mais você contratar, maior é o seu desconto!
                    </S.AdditionalText>

                    {/* <S.AdditionalText>
                        *Para mais usuários ou receitas, <a href='/simulacaoplano/7'>simule aqui</a>. <br/>Quanto mais você contratar, maior é o seu desconto!
                    </S.AdditionalText> */}
                </S.TableCell>
                {gridAnual
                    .filter(g => g.plan_id !== 6)
                    .map((g, index) => {
                        const campaignPlan = props.campaign?.agro_campaign_plans?.find(p => p.agro_plan_id === g.plan_id);
                        const gridMensal = grid.find(m => m.plan_id === g.plan_id);
                        const oldVlr = campaignPlan ? g.vlr : (gridMensal ? gridMensal.vlr : g.vlr);
                        const oldCents = campaignPlan ? g.cents : (gridMensal ? gridMensal.cents : g.cents);
                        return (
                        <S.TableCell key={index}>
                            <S.PriceWithButtonContainer>
                                <S.OldPrice>
                                    <span className="currency-symbol">R$</span>
                                    <span>{oldVlr}</span>
                                    <span className="cents">,{oldCents}</span>
                                </S.OldPrice>

                                {campaignPlan ? (
                                    (() => {
                                        const valueNum = Number(String(campaignPlan.valor_desconto ?? ''));
                                        const brl = valueNum.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
                                        const [finalInt, finalCents] = brl.split(',');
                                        return (
                                            <S.Price promo={true}>
                                                <span className="currency-symbol">R$</span>
                                                <span>{finalInt}</span>
                                                <span className="cents">,{finalCents}*</span>
                                            </S.Price>
                                        );
                                    })()
                                ) : (
                                    <S.Price>
                                        <span className="currency-symbol">R$</span>
                                        <span>{g.vlr}</span>
                                        <span className="cents">,{g.cents}</span>
                                    </S.Price>
                                )}

                                <S.PriceDescription>mensais por usuário</S.PriceDescription>
                                <S.PriceDescriptionForAnual>NO PLANO ANUAL</S.PriceDescriptionForAnual>

                                {g.plan_id === 7 ? (
                                    SubscribeBasic()
                                ) : g.plan_id === 4 ? (
                                    subscribeLight()
                                ) : g.plan_id === 5 ? (
                                    subscribePro()
                                ) : null}
                            </S.PriceWithButtonContainer>
                        </S.TableCell>
                        );
                    })}
                </S.PriceRow>
                )
            }}

            const PriceContainerMobile = () => {
                if (props.showPlanTablePrices === false) {
                    if (props.location.pathname === '/receituario-agronomico-2026b') {
                        return (
                            <S.ButtonBelowPrices>
                                <Button value='TESTE GRÁTIS AGORA' margin='25px 0' height='54px' width='200px' onClick={() => window.location.href=`/cadastro${searchCadastro}`} />
                            </S.ButtonBelowPrices>
                        );
                    }
                    return null;
                }
                const mobileRows = gridAnual
                    .filter(g => g.plan_id !== 6)
                    .map((g, index) => {
                        const campaignPlan = props.campaign?.agro_campaign_plans?.find(p => p.agro_plan_id === g.plan_id);
                        const gridMensal = grid.find(m => m.plan_id === g.plan_id);
                        const oldVlr = campaignPlan ? g.vlr : (gridMensal ? gridMensal.vlr : g.vlr);
                        const oldCents = campaignPlan ? g.cents : (gridMensal ? gridMensal.cents : g.cents);
                        return (
                            <S.MobilePriceBox key={index} positionMiddle={index === 1}>
                                <S.MobilePlans>
                                    {g.plan_id === 7 ? "Plano Basic" :
                                        g.plan_id === 4 ? "Plano Light" :
                                            g.plan_id === 5 ? "Plano Pro" : ""}
                                </S.MobilePlans>

                                <S.OldPrice promo={true} isMobile={true}>
                                    <span className="currency-symbol">R$</span>
                                    <span>{oldVlr}</span>
                                    <span className="cents">,{oldCents}</span>
                                </S.OldPrice>

                                {campaignPlan ? (
                                    (() => {
                                        const valueNum = Number(String(campaignPlan.valor_desconto ?? ''));
                                        const brl = valueNum.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
                                        const [finalInt, finalCents] = brl.split(',');
                                        return (
                                            <S.NewPrice promo={true} isMobile={true}>
                                                <span className="currency-symbol">R$</span>
                                                <span>{finalInt}</span>
                                                <span className="cents">,{finalCents}*</span>
                                            </S.NewPrice>
                                        );
                                    })()
                                ) : (
                                    <S.Price isMobile={true}>
                                        R$ <span>{g.vlr},{g.cents}</span>
                                    </S.Price>
                                )}

                                <S.PriceDescription isMobile={true}>mensais por usuário</S.PriceDescription>
                                <S.PriceDescriptionForAnual isMobile={true}>NO PLANO ANUAL</S.PriceDescriptionForAnual>
                            </S.MobilePriceBox>
                        );
                    });

                if (props.location.pathname === '/receituario-agronomico-2026') {
                    return <S.MobilePriceContainer>{mobileRows}</S.MobilePriceContainer>;
                } else {
                    return <S.MobilePriceContainer>{mobileRows}</S.MobilePriceContainer>;
                }
            }

            const TablePrepaid = () => {
                // Filtra o plano pré-pago (id 6)
                const prepaidPlan = planos.find(plano => plano.id === 6);
                const prepaidGrid = grid.find(g => g.plan_id === 6);

                if (!prepaidPlan || !prepaidGrid) {
                    return <p>Carregando dados do plano pré-pago...</p>;
                }

                return (
                    <S.MainContainer className='plans'>
                        <S.Title className='plans'>Tome melhores decisões com o AgroReceita</S.Title>
                        <S.Subtitle className='plans'>Faça como as empresas abaixo e escolha o melhor plano para sua necessidade</S.Subtitle>

                        <Carousel />

                        <S.ContainerTable isPrepaid={true}>
                            <S.Table>
                                <S.TableHead>
                                    <S.TableRow isPrepaid={true}>
                                        <S.TableHeader isPrepaid={true}><img src={logo} alt='Icone' width="20" className='icon' /></S.TableHeader>
                                        <S.TableHeader isPrepaid={true}>Pré-Pago</S.TableHeader>
                                    </S.TableRow>
                                </S.TableHead>
                                <S.TableBody>
                                    {headers.length > 0 && permissoes.length > 0 ? (
                                        headers.map((header, index) => {
                                            const normalizeText = (text) =>
                                                (text || '')
                                                    .toString()
                                                    .normalize('NFD')
                                                    .replace(/[\u0300-\u036f]/g, '')
                                                    .toLowerCase()
                                                    .trim()
                                                    .replace(/\s+/g, ' ');

                                            const functionInfo =
                                                DescriptionFunctions.find((f) => f.descricao === header.descricao) ||
                                                DescriptionFunctions.find(
                                                    (f) => normalizeText(f.descricao) === normalizeText(header.descricao)
                                                );

                                            const descricaoBreve = functionInfo?.descricaoBreve;

                                            // Encontra a permissão correspondente para o plano pré-pago (id 6)
                                            const permissao = permissoes.find(
                                                per => per.agro_plan_function_id === header.id && per.plan_id === 6
                                            );

                                            // Verifica se é o item "Emissão de Receitas"
                                            if (header.id === 1) { // Substitua 1 pelo ID correto da função "Emissão de Receitas"
                                                return (
                                                    <S.TableRow key={index} isPrepaid={true}>
                                                        <S.TableCell isPrepaid={true}>
                                                            <S.ContainerCell isPrepaid={true}>
                                                                <BodyM fontWeight={700}>{header.descricao}</BodyM>

                                                                {descricaoBreve ? (
                                                                    <Auxiliar color={theme.colors.gray.Cinza_5}>
                                                                        <span dangerouslySetInnerHTML={{ __html: descricaoBreve }} />
                                                                    </Auxiliar>
                                                                ) : null}
                                                            </S.ContainerCell>
                                                        </S.TableCell>
                                                        <S.TableCell isPrepaid={true} style={{ fontSize: '14px' }}>
                                                            Compre créditos que não expiram nunca
                                                        </S.TableCell>
                                                    </S.TableRow>
                                                );
                                            } else {
                                                return (
                                                    <S.TableRow key={index} isPrepaid={true}>
                                                        <S.TableCell isPrepaid={true}>
                                                            <S.ContainerCell isPrepaid={true}>
                                                                <BodyM fontWeight={700}>{header.descricao}</BodyM>
                                                                {descricaoBreve ? (
                                                                    <Auxiliar color={theme.colors.gray.Cinza_5}>
                                                                        <span dangerouslySetInnerHTML={{ __html: descricaoBreve }} />
                                                                    </Auxiliar>
                                                                ) : null}
                                                            </S.ContainerCell>
                                                        </S.TableCell>
                                                        <S.TableCell isPrepaid={true}>
                                                            {permissao?.status === 1 ? (
                                                                <img isPrepaid={true} src={check} alt="Certo" width="15%" />
                                                            ) : (
                                                                <img isPrepaid={true} src={x} alt="Errado" width="15%" />
                                                            )}
                                                        </S.TableCell>
                                                    </S.TableRow>
                                                );
                                            }
                                        })
                                    ) : (
                                        <p>Carregando funcionalidades...</p>
                                    )}

                                    <S.SupportRow isPrepaid={true}>
                                        <S.TableCell isPrepaid={true}>
                                            <S.SupportTitle isPrepaid={true}>Suporte</S.SupportTitle>
                                        </S.TableCell>
                                        <S.TableCell isPrepaid={true}>
                                            <S.SupportPlanName isPrepaid={true}>Suporte Plano Pré-Pago</S.SupportPlanName>
                                            <S.SupportList isPrepaid={true}>
                                                <S.SupportItem>WhatsApp</S.SupportItem>
                                                <S.SupportItem>E-mail</S.SupportItem>
                                                <S.SupportItem>Central de Ajuda</S.SupportItem>
                                            </S.SupportList>
                                        </S.TableCell>
                                    </S.SupportRow>

                                    <S.PriceRow isPrepaid={true} className='pre-paid-price'>
                                        <S.TableCell>
                                            {/* <S.AdditionalText isPrepaid={true}>
                                                *Válido para os primeiros 12 meses<br/>Para mais usuários ou receitas, <a onClick={() => window.location = '/simulacaoplano/7?'}>simule aqui.</a> <br/>Quanto mais você contratar, maior é o seu desconto!
                                            </S.AdditionalText> */}

                                            <S.AdditionalText isPrepaid={true}>
                                                *Para mais usuários ou receitas, <a href='/simulacaoplano/7'>simule aqui</a>. <br/>Quanto mais você contratar, maior é o seu desconto!
                                            </S.AdditionalText>
                                        </S.TableCell>
                                        <S.TableCell className='price-prepaid'>
                                            <S.PriceWithButtonContainer isPrepaid={true}>

                                                {props.campaign && props.campaign.agro_campaign_plans && props.campaign.agro_campaign_plans.find(p => p.agro_plan_id === 6) ? (
                                                    (() => {
                                                        const item = props.campaign.agro_campaign_plans.find(p => p.agro_plan_id === 6);
                                                        const valueStr = String(item?.valor_desconto ?? '');
                                                        const valueNum = Number(valueStr);
                                                        const brl = valueNum.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
                                                        const [finalInt, finalCents] = brl.split(',');
                                                        return (
                                                            <>
                                                                <S.OldPrice prePago={true}>
                                                                    <span className="currency-symbol">R$</span>
                                                                    <span>{prepaidGrid.vlr}</span>
                                                                    <span className="cents">,{prepaidGrid.cents}*</span>
                                                                </S.OldPrice>
                                                                <S.NewPrice prePago={true}>
                                                                    <span className="currency-symbol">R$</span>
                                                                    <span>{finalInt}</span>
                                                                    <span className="cents">,{finalCents}*</span>
                                                                </S.NewPrice>
                                                            </>
                                                        );
                                                    })()
                                                ) : (
                                                    <S.Price isPrepaid={true}>
                                                        <span className="currency-symbol">R$</span>
                                                        <span>{prepaidGrid.vlr}</span>
                                                        <span className="cents">,{prepaidGrid.cents}</span>
                                                    </S.Price>
                                                )}

                                                {/* PREÇO COM DESCONTO */}
                                                {/* <S.OldPrice prePago={true}>
                                                    <span className="currency-symbol">R$</span>
                                                    <span>{prepaidGrid.vlr}</span>
                                                    <span className="cents">,{prepaidGrid.cents}*</span>
                                                </S.OldPrice> */}

                                                {/* NewPrice */}
                                                {/* <S.NewPrice prePago={true}>
                                                    <span className="currency-symbol">R$</span>

                                                    <span>
                                                        {prepaidGrid.plan_id === 6 ? "3" : ""} 
                                                    </span>

                                                    <span className="cents">
                                                        {prepaidGrid.plan_id === 6 ? ",43*" : ""}
                                                    </span>
                                                </S.NewPrice> */}

                                                <S.PriceDescriptionPrePago>por Receituário</S.PriceDescriptionPrePago>
                                            
                                                <S.PriceDescription isPre={true}>DESCONTO PROGRESSIVO</S.PriceDescription>

                                                <Button
                                                    value='Comprar Créditos'
                                                    margin='15px 0'
                                                    height='36px'
                                                    width='100%'
                                                    onClick={() => assinar(6)}
                                                />
                                            </S.PriceWithButtonContainer>
                                        </S.TableCell>
                                    </S.PriceRow>
                                </S.TableBody>
                            </S.Table>
                            <S.PrePaidPlanContainer isPrepaid={true}>
                                Conheça os <button onClick={() => {setShowPrepaid(false); window.history.back()}}><a>Planos de Assinatura</a></button> e emita seus Receituários Agronômicos com tranquilidade.
                            </S.PrePaidPlanContainer>
                        </S.ContainerTable>
                    </S.MainContainer>
                );
            };


            const isPlans = () => {
                if (showPrepaid) {
                    return (
                        <>
                            {TablePrepaid()}
                        </>
                    )
                }
                if (props.location.pathname === '/planos') {
                    return (
                        <S.MainContainer className='plans'>

                            <S.Title className='plans'>Tome melhores decisões com o AgroReceita</S.Title>
                            <S.Subtitle className='plans'>Faça como as empresas abaixo e escolha o melhor plano para sua necessidade</S.Subtitle>

                            <Carousel />

                            <S.ContainerTable isPrepaid={false}>
                                <S.Table>
                                    <S.TableHead>
                                        <S.TableRow>
                                            <S.TableHeader><img src={logo} alt='Icone' width="20" className='icon' /></S.TableHeader>
                                            <S.TableHeader>Plano Basic</S.TableHeader>
                                            <S.TableHeader>Plano Light</S.TableHeader>
                                            <S.TableHeader>Plano Pro</S.TableHeader>
                                        </S.TableRow>
                                    </S.TableHead>
                                    <S.TableBody>
                                        {headers.length > 0 && planos.length > 0 && permissoes.length > 0 ? (
                                            headers.map((header, index) => {
                                                const normalizeText = (text) =>
                                                    (text || '')
                                                        .toString()
                                                        .normalize('NFD')
                                                        .replace(/[\u0300-\u036f]/g, '')
                                                        .toLowerCase()
                                                        .trim()
                                                        .replace(/\s+/g, ' ');

                                                const functionInfo =
                                                    DescriptionFunctions.find((f) => f.descricao === header.descricao) ||
                                                    DescriptionFunctions.find(
                                                        (f) => normalizeText(f.descricao) === normalizeText(header.descricao)
                                                );

                                                const descricaoBreve = functionInfo?.descricaoBreve;

                                                return (
                                                    <S.TableRow key={index}>
                                                        <S.TableCell isPrepaid={false}>
                                                            <S.ContainerCell isPrepaid={false}>
                                                                <BodyM fontWeight={700}>{header.descricao}</BodyM>

                                                                {descricaoBreve ? (
                                                                    <Auxiliar color={theme.colors.gray.Cinza_5}>
                                                                        <span dangerouslySetInnerHTML={{ __html: descricaoBreve }} />
                                                                    </Auxiliar>
                                                                ) : null}
                                                            </S.ContainerCell>
                                                        </S.TableCell>
                                                    {planos
                                                        .filter(plano => plano.id !== 6) // Filtra para remover o plano pré-pago (id 6)
                                                        .map((plano) => {
                                                            // Encontra a permissão correspondente
                                                            const permissao = permissoes.find(
                                                                per => per.agro_plan_function_id === header.id && per.plan_id === plano.id
                                                            );

                                                            // Verifica se é o item "Emissão de Receitas"
                                                            if (header.id === 1) { // Substitua 1 pelo ID correto da função "Emissão de Receitas"
                                                                return (
                                                                    <S.TableCell key={plano.id} isPrepaid={false}>
                                                                        {permissao?.descricao || "Não disponível"}
                                                                    </S.TableCell>
                                                                );
                                                            } else {
                                                                return (
                                                                    <S.TableCell key={plano.id} isPrepaid={false}>
                                                                        {permissao?.status === 1 ? (
                                                                            <img isPrepaid={false} src={check} alt="Certo" width="30" />
                                                                        ) : (
                                                                            <img isPrepaid={false} src={x} alt="Errado" width="30" />
                                                                        )}
                                                                    </S.TableCell>
                                                                );
                                                            }
                                                        })}
                                                </S.TableRow>
                                                );
                                            })
                                        ) : (
                                            <></>
                                        )}

                                        <S.SupportRow className='support-row'>
                                            <S.TableCell className='support-row'>
                                                <S.SupportTitle isPrepaid={false}>Suporte</S.SupportTitle>
                                            </S.TableCell>

                                            <S.TableCell className='support-row'>
                                                <S.SupportPlanName>Suporte Plano<br />Basic</S.SupportPlanName>
                                                <S.SupportList>
                                                    <S.SupportItem>WhatsApp</S.SupportItem>
                                                    <S.SupportItem>E-mail</S.SupportItem>
                                                    <S.SupportItem>Central de Ajuda</S.SupportItem>
                                                </S.SupportList>
                                            </S.TableCell>

                                            <S.TableCell className='support-row'>
                                                <S.SupportPlanName>Suporte Plano<br />Light</S.SupportPlanName>
                                                <S.SupportList>
                                                    <S.SupportItem>Telefone</S.SupportItem>
                                                    <S.SupportItem>WhatsApp</S.SupportItem>
                                                    <S.SupportItem>E-mail</S.SupportItem>
                                                    <S.SupportItem>Central de Ajuda</S.SupportItem>
                                                </S.SupportList>
                                            </S.TableCell>

                                            <S.TableCell className='support-row'>
                                                <S.SupportPlanName>Suporte Plano<br />Pro</S.SupportPlanName>
                                                <S.SupportList>
                                                    <S.SupportItem>Suporte Prioritário</S.SupportItem>
                                                    <S.SupportItem>Telefone</S.SupportItem>
                                                    <S.SupportItem>WhatsApp</S.SupportItem>
                                                    <S.SupportItem>E-mail</S.SupportItem>
                                                    <S.SupportItem>Central de Ajuda</S.SupportItem>
                                                </S.SupportList>
                                            </S.TableCell>
                                        </S.SupportRow>

                                        {PriceContainerDesktop()}

                                    </S.TableBody>
                                </S.Table>

                                <S.DeskContainerButtonPrePago>
                                    <S.PrePaidPlanContainer>
                                        Conheça o <button onClick={() => setShowPrepaid(true)}><a href='#'>Plano Pré-Pago</a></button> e compre créditos para utilizar quando quiser.
                                    </S.PrePaidPlanContainer>
                                </S.DeskContainerButtonPrePago>
                            </S.ContainerTable>


                            {PriceContainerMobile()}

                            <S.ButtonBelowPrices>
                                {props.showPlanTablePrices !== false ? SubscribeMobile() : <></>}
                            </S.ButtonBelowPrices>

                            <S.MobileAdditionalTextContainer>
                                <S.MobileAdditionalText>
                                    *Válido para os primeiros 12 meses<br/>Para mais usuários ou receitas, <a onClick={() => window.location = '/simulacaoplano/7?'}>simule aqui.</a> <br/>Quanto mais você contratar, maior é o seu desconto!
                                </S.MobileAdditionalText>

                                {/* <S.MobileAdditionalText>
                                    *Para mais usuários ou receitas, <a href='/simulacaoplano/7'>simule aqui</a>. <br/>Quanto mais você contratar, maior é o seu desconto!
                                </S.MobileAdditionalText> */}
                            </S.MobileAdditionalTextContainer>

                            <S.MobileContainerButtonPrePago>
                                <S.PrePaidPlanContainer>
                                    Conheça o <button onClick={() => setShowPrepaid(true)}><a href='#'>Plano Pré-Pago</a></button> e compre créditos para utilizar quando quiser.
                                </S.PrePaidPlanContainer>
                            </S.MobileContainerButtonPrePago>
                        </S.MainContainer>
                    );
                } else {
                    return (
                        <S.MainContainer className='receituario'>

                            <S.Title>Tome melhores decisões com o AgroReceita</S.Title>
                            <S.Subtitle>Faça como as empresas abaixo e escolha o melhor plano para sua necessidade</S.Subtitle>

                            <S.ContainerTable className='receituario' isPrepaid={false}>
                                <S.Table>
                                    <S.TableHead>
                                        <S.TableRow>
                                            <S.TableHeader><img src={logo} alt='Icone' width="30" className='icon' /></S.TableHeader>
                                            <S.TableHeader>Plano Basic</S.TableHeader>
                                            <S.TableHeader>Plano Light</S.TableHeader>
                                            <S.TableHeader>Plano Pro</S.TableHeader>
                                        </S.TableRow>
                                    </S.TableHead>
                                    <S.TableBody>
                                        {headers.length > 0 && planos.length > 0 && permissoes.length > 0 ? (
                                            headers.map((header, index) => {
                                                const normalizeText = (text) =>
                                                    (text || '')
                                                        .toString()
                                                        .normalize('NFD')
                                                        .replace(/[\u0300-\u036f]/g, '')
                                                        .toLowerCase()
                                                        .trim()
                                                        .replace(/\s+/g, ' ');

                                                const functionInfo =
                                                    DescriptionFunctions.find((f) => f.descricao === header.descricao) ||
                                                    DescriptionFunctions.find(
                                                        (f) => normalizeText(f.descricao) === normalizeText(header.descricao)
                                                    );

                                                const descricaoBreve = functionInfo?.descricaoBreve;

                                                return (
                                                    <S.TableRow key={index}>
                                                        <S.TableCell isPrepaid={false}>
                                                            <S.ContainerCell isPrepaid={false}>
                                                                <BodyM fontWeight={700}>{header.descricao}</BodyM>
                                                                {descricaoBreve ? (
                                                                    <Auxiliar color={theme.colors.gray.Cinza_5}>
                                                                        <span dangerouslySetInnerHTML={{ __html: descricaoBreve }} />
                                                                    </Auxiliar>
                                                                ) : null}
                                                            </S.ContainerCell>
                                                        </S.TableCell>
                                                        {planos
                                                            .filter(plano => plano.id !== 6) // Filtra para remover o plano pré-pago (id 6)
                                                            .map((plano) => {
                                                                // Encontra a permissão correspondente
                                                                const permissao = permissoes.find(
                                                                    per => per.agro_plan_function_id === header.id && per.plan_id === plano.id
                                                                );

                                                                // Verifica se é o item "Emissão de Receitas"
                                                                if (header.id === 1) { // Substitua 1 pelo ID correto da função "Emissão de Receitas"
                                                                    return (
                                                                        <S.TableCell key={plano.id} isPrepaid={false}>
                                                                            {permissao?.descricao || "Não disponível"}
                                                                        </S.TableCell>
                                                                    );
                                                                } else {
                                                                    return (
                                                                        <S.TableCell key={plano.id} isPrepaid={false}>
                                                                            {permissao?.status === 1 ? (
                                                                                <img isPrepaid={false} src={check} alt="Certo" width="30" />
                                                                            ) : (
                                                                                <img isPrepaid={false} src={x} alt="Errado" width="30" />
                                                                            )}
                                                                        </S.TableCell>
                                                                    );
                                                                }
                                                            })}
                                                    </S.TableRow>
                                                );
                                            })
                                        ) : (
                                            <p>Carregando dados...</p>
                                        )}

                                        <S.SupportRow className='support-row'>
                                            <S.TableCell className='support-row'>
                                                <S.SupportTitle isPrepaid={false}>Suporte</S.SupportTitle>
                                            </S.TableCell>
                                            <S.TableCell className='support-row'>
                                                <S.SupportPlanName>Suporte Plano<br />Basic</S.SupportPlanName>
                                                <S.SupportList>
                                                    <S.SupportItem>WhatsApp</S.SupportItem>
                                                    <S.SupportItem>E-mail</S.SupportItem>
                                                    <S.SupportItem>Central de Ajuda</S.SupportItem>
                                                </S.SupportList>
                                            </S.TableCell>
                                            <S.TableCell className='support-row'>
                                                <S.SupportPlanName>Suporte Plano<br />Light</S.SupportPlanName>
                                                <S.SupportList>
                                                    <S.SupportItem>Telefone</S.SupportItem>
                                                    <S.SupportItem>WhatsApp</S.SupportItem>
                                                    <S.SupportItem>E-mail</S.SupportItem>
                                                    <S.SupportItem>Central de Ajuda</S.SupportItem>
                                                </S.SupportList>
                                            </S.TableCell>
                                            <S.TableCell className='support-row'>
                                                <S.SupportPlanName>Suporte Plano<br /> Pro</S.SupportPlanName>
                                                <S.SupportList>
                                                    <S.SupportItem>Suporte Prioritário</S.SupportItem>
                                                    <S.SupportItem>Telefone</S.SupportItem>
                                                    <S.SupportItem>WhatsApp</S.SupportItem>
                                                    <S.SupportItem>E-mail</S.SupportItem>
                                                    <S.SupportItem>Central de Ajuda</S.SupportItem>
                                                </S.SupportList>
                                            </S.TableCell>
                                        </S.SupportRow>

                                        {PriceContainerDesktop()}

                                    </S.TableBody>
                                </S.Table>
                            </S.ContainerTable>


                            {PriceContainerMobile()}

                            <S.ButtonBelowPrices>
                                {SubscribeMobile()}
                            </S.ButtonBelowPrices>

                           

                            <S.MobileAdditionalTextContainer>
                                {/* <S.MobileAdditionalText>
                                    *Válido para os primeiros 12 meses<br/>Para mais usuários ou receitas, <a onClick={() => window.location = '/simulacaoplano/7?'}>simule aqui.</a> <br/>Quanto mais você contratar, maior é o seu desconto!
                                </S.MobileAdditionalText> */}

                                <S.MobileAdditionalText>
                                    *Para mais usuários ou receitas, <a href='/simulacaoplano/7'>simule aqui</a>. <br/>Quanto mais você contratar, maior é o seu desconto!
                                </S.MobileAdditionalText>

                                {width <= 1237 ? (
                                    <S.ShowPrePaidPlanContainer>
                                        <S.PrePaidPlanContainer isPrepaid={true}>
                                        Conheça o <button onClick={() => setShowPrepaid(true)}><a href='/planos'>Plano Pré-Pago</a></button> e compre créditos para utilizar quando quiser.
                                        </S.PrePaidPlanContainer>
                                    </S.ShowPrePaidPlanContainer>
                                ): ""}
                            </S.MobileAdditionalTextContainer>

                            

                            
                        </S.MainContainer>
                    );
                }
            }

            return (
                <>
                    {isPlans()}
                </>
            )

        }

        export default withRouter(PlanTableWithCupom);